module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-proveedores-grupos/catalogo-proveedores-grupos.component.scss
// module id = ./src/app/components/catalogo-proveedores-grupos/catalogo-proveedores-grupos.component.scss
// module chunks = main